if (!customElements.get('mega-menu-deep')) {
  class MegaMenuDeep extends HTMLElement {
    connectedCallback() {
      this.#sidebar?.addEventListener('click', this.#onSidebarClick);
      this.#sidebar?.addEventListener('keydown', this.#onSidebarKeydown);
    }

    disconnectedCallback() {
      this.#sidebar?.removeEventListener('click', this.#onSidebarClick);
      this.#sidebar?.removeEventListener('keydown', this.#onSidebarKeydown);
    }

    get #sidebar() {
      return this.querySelector('.mega-menu__deep-sidebar');
    }

    /** @param {Event} e */
    #onSidebarClick = (e) => {
      const btn = e.target instanceof Element ? e.target.closest('.mega-menu__sidebar-item') : null;
      if (!btn || !(btn instanceof HTMLButtonElement)) return;
      this.#activateIndex(btn.dataset.deepIndex);
    };

    /** @param {KeyboardEvent} e */
    #onSidebarKeydown = (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const btn = e.target instanceof Element ? e.target.closest('.mega-menu__sidebar-item') : null;
      if (!btn || !(btn instanceof HTMLButtonElement)) return;
      e.preventDefault();
      this.#activateIndex(btn.dataset.deepIndex);
    };

    /** @param {string | undefined} index */
    #activateIndex(index) {
      if (!index) return;

      this.#sidebar?.querySelectorAll('.mega-menu__sidebar-item').forEach((el) => {
        const isMatch = el instanceof HTMLElement && el.dataset.deepIndex === index;
        el.classList.toggle('is-active', Boolean(isMatch));
        if (el instanceof HTMLButtonElement) {
          el.setAttribute('aria-expanded', isMatch ? 'true' : 'false');
        }
      });

      this.querySelectorAll('.mega-menu__deep-panel').forEach((panel) => {
        const isMatch = panel instanceof HTMLElement && panel.dataset.deepPanel === index;
        panel.classList.toggle('is-active', Boolean(isMatch));
        if (isMatch) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  customElements.define('mega-menu-deep', MegaMenuDeep);
}
